import { mode } from "@chakra-ui/theme-tools";
import { flex } from "./flex";
import { mdxStyles } from "./mdx-styles";
import { reactApexChartStyles } from "./react-apex-charts";
import textStyles from "./text-styles";
import { CustomStyleFunctionProps } from "./types";
import { widgetStyles } from "./widget-styles";
import { wrapperStyles } from "./wrapper-styles";
export default {
  global: (props: CustomStyleFunctionProps) => ({
    html: {
      scrollBehavior: "smooth",
      minWidth: "360px",
    },
    "#__next": {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      bg: mode("white", "black")(props),
    },
    body: {
      color: "default",
      bg: "bg-canvas",
      fontFamily: "body",
      lineHeight: "base",
    },
    a: {
      color: mode("blue.500", "blue.300")(props),
      textDecoration: "none",
      _hover: {
        textDecoration: "underline",
      },
    },
    "*::placeholder": {
      opacity: 1,
      color: "subtle",
    },
    "*, *::before, &::after": {
      borderColor: mode("blueGray.200", "blueGray.300")(props),
    },
    ...reactApexChartStyles(props),
  }),
  mdx: mdxStyles,
  mdxStyles,
  textStyles,
  widgetStyles,
  wrapperStyles,
  flex,
};

export * from "./mdx-styles";
